// Object Storage utility for accessing files from Replit's Object Storage

export const getObjectStorageUrl = (objectName: string): string => {
  // For now, we're using the public assets directory since we've copied the files there
  return `/assets/${objectName}`;
};

export const logoUrls = {
  darkMode: getObjectStorageUrl('darkmodelogo.png'),
  lightMode: getObjectStorageUrl('lightmodelogo.png')
};